// extracted by mini-css-extract-plugin
export default {"cls1":"Tooltip-cls1_kjk","cls2":"Tooltip-cls2_V3v Tooltip-cls1_kjk"};